module.exports = __webpack_public_path__ + "img/68.f00d2f27.jpg";